import moment from "moment";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { getData, postData } from "../../Service/ApiMethod";
import { Recruiter_Create_Message, UNLOCKED_PROFILES } from "../../Service/service";
import UnlockedProfileBlackScreen from "../home/UnlockedProfileBlackScreen";
import AddToList from "../Vaccancy/AddToList";
import { GetReflectOnRound } from "./UnlockedProfile";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

const UnlockedRoundProfileBox = (props) => {
  const [detail, setDeatil] = useState();
  const [unlockedBlackScreen, setUnlockedBlackScreen] = useState(false)
  const [indexing, setIndexing] = useState()
  const [createListPopup, setCreateListPopup] = useState()
  const [addListPopupIndexing, setAddListPopupIndexing] = useState()
  const [showcall, setShowcall] = useState(false)
  const [showemail, setShowemail] = useState(false)
  const [callIndexing, setCallIndexing] = useState()
  const [emailIndexing, setEmailIndexing] = useState()

  const filteredUsers = props?.filteredUsersData

  const setChangeInRound = useContext(GetReflectOnRound)

  const getfilteredUsers = (candidates) => {
    setDeatil(candidates)
  }

  console.log('filteredUsers', detail)

  useEffect(() => {
    getfilteredUsers(filteredUsers)
  })

  const navigate = useNavigate()


  const handleMessage = (id) => {
    const obj = {
      "jobseeker_id": id
    }
    postData(obj, Recruiter_Create_Message)
      .then(res => res.json())
      .then(data => {
        console.log('get message candidate response', data?.data)
        // setCandidateMessageData(data.data)
        navigate('/message', { state: { data: data?.data } })
      })
      .catch((err) => {
        console.log(err.message)
      })
  }





  return (
    <>
      {(detail?.length != 0)
        ? detail?.map((item, index) => {
          return (
            <div className="w-100" key={index} onClick={(e) => {
              e.stopPropagation()
              setIndexing(index)
              setUnlockedBlackScreen(true)
            }}>
              <div className="recommended-profile recommendedprofile-outerr d-flex align-items-start">
                <div className="row ">
                  <div className="recommended-profile-left recommended-profile-desc justify-content-center px-0 relative flex-center d-flex flex-column">
                    <img
                      src={item?.cand_image || "./images/Vector.png"}
                      alt=" "
                      className="card-img img-fluid"
                      // style={{ height: '200px' }}
                    />
                    <p className="hire-status">{item?.round_status}</p>
                    <div className="icons-profile">
                      <div className="">
                        <img
                          src="./images/call-reciever.png"
                          className="profile-btn "
                          // title="Call"
                          alt=""
                          onClick={(e) => {
                            e.stopPropagation()
                            setCallIndexing(index)
                            setShowcall(!showcall)
                            if (showemail) {
                              setShowemail(!showemail)
                            }
                          }}
                        />
                      </div>
                      {showcall && (callIndexing == index) &&
                        <>
                          <sapn style={{ width: '120px', height: '20px', textAlign: 'center', position: 'inherit', zIndex: '99999999', background: 'black', color: 'white', bottom: '100%', borderRadius: '5px' }}>{item?.candidate[0]?.mobile_number}</sapn>
                        </>
                      }
                      <div className="">
                        <img
                          src="./images/email.png"
                          className="profile-btn "
                          title="Mail"
                          alt=""
                          onClick={(e) => {
                            e.stopPropagation()
                            setEmailIndexing(index)
                            setShowemail(!showemail)
                            if (showcall) {
                              setShowcall(!showcall)
                            }
                          }}
                        />
                      </div>
                      {showemail && (emailIndexing == index) &&
                        <>
                          <span style={{ width: '14em', height: '20px', textAlign: 'center', position: 'inherit', zIndex: '99999999', background: 'black', color: 'white', bottom: '100%', borderRadius: '5px' }}>{item?.candidate[0]?.email}</span>
                        </>
                      }
                      <div className=""
                        onClick={(e) => {
                          e.stopPropagation()
                          handleMessage(item?.candidate_id)


                        }}

                      >
                        <img

                          src="./images/msg-profile.png"
                          className="profile-btn"
                          // title="Message"
                          alt=""
                        />
                      </div>
                    </div>
                      
                  
                  </div>
                  <div className="recommended-profile-right pr-0 ">
                  <div className="d-flex relative">
                    <h2 className="card-heding relative">
                      {item.first_name}{" "}
                      {item.last_name}
                      {/* <img
                          src="./images/verified.png"
                          className="ml-2"
                          alt=""
                        />
                        <span className="verified">Verified</span> */}
                      
                    </h2>
             
                          <img
                            src="./images/match-badge.png"
                            className="img-size18 match-badge"
                            alt=""
                          />
                          <span className="ms-1 match-profile">
                            {parseInt(item?.percentage_match)}% {t('Match')}
                          </span>
                          <img
                        src="./images/send-job.png"
                        alt=""
                        className="addprofile"
                        // onClick={(e) => {
                        //   e.stopPropagation()
                        //   // props?.addList()
                        //   setAddToListIndexing(index)
                        //   setCreateListAll(true)
                        // }}
                        style={{  }}
                      />
                 
                    </div>
                    <p className="designation">{item?.profile_title}</p>
                    {(parseInt(item?.availability)) > 0 &&
                      <p className="profile-availbility">({t('Available')} {item?.availability})</p>
                    }
                    <div className="row mt-2 align-items-center">
                      <div className="col-5 px-0">
                        <p className="card-subHeading">{t('Total Experience')}</p>
                        <p className="card-subHeading">{t('Current Location')}</p>
                        <p className="card-subHeading">{t('Package')}</p>
                      </div>
                      <div className="col-7">
                        <p className="profile-info"> {item?.experience_id} {(item?.experience_id > 1) ? 'Years' : 'Year'}</p>
                        <p className="profile-info">{parseInt(item?.distance)} {t('KM Away')}</p>
                        <p className="profile-info">{item?.currency} {item?.expected_salary} {item?.compensation_details}</p>
                        
                        <div className="unlocked-status">
                          <p className="unlocked-time">
                            {t('Unlocked on')} {moment(item?.unlocked_on).format('D MMM YYYY, h:mm A')}
                          </p>
                        </div>
                      </div>
                    
                    
                      
                  
                    </div>
                  </div>
                </div>
              </div>
              {unlockedBlackScreen && indexing == index &&
                <>
                  <div className='blur-screen-full-area flex-center' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', background: 'rgb(0, 0, 0, 0.7' }}>
                    <UnlockedProfileBlackScreen item={item} setBlackPopupValue={setUnlockedBlackScreen} setChangeInRound={setChangeInRound} />
                  </div>
                </>
              }

              {createListPopup && (addListPopupIndexing == index) && (
                <AddToList
                  closePopup={() => {
                    setCreateListPopup(!createListPopup)
                  }}
                  seekerID={item?.candidate_id
                  }
                />
              )}
            </div>
          );
        })
        :
        <div className='emptyRoundScreen'>


          {t('No Candidate Available')}
        </div>
      }
    </>
  );
};

export default UnlockedRoundProfileBox;
